import o from "../../node_modules/classnames/index.js";
import { jsx as t } from "../../_virtual/jsx-runtime.js";
function e({
  className: r,
  children: m
}) {
  return /* @__PURE__ */ t("div", {
    className: o("form-grid__sub-title", r),
    children: m
  });
}
export {
  e as FormSubTitle
};
//# sourceMappingURL=FormSubTitle.js.map
